import { sdkRequest } from '@eventbrite/http';
import { gettext } from '@eventbrite/i18n';

export const STANDARD_SERVER_ERROR = gettext(
    'There was an issue with the server, try again',
);

export interface OnboardingResponses {
    data: OnboardingResponse[];
}

export interface OnboardingResponse {
    question_id: string;
    answers: Answer[];
}

interface Answer {
    id: number;
    value: string;
}

const getOnboardingResponsesUrl = (organizationId: string): string =>
    `/onboarding/organizations/${organizationId}/responses/`;

export const getOnboardingResponses = (
    organizationId: string,
): Promise<OnboardingResponses> =>
    sdkRequest(getOnboardingResponsesUrl(organizationId));

export const saveResponses = (
    organizationId: string,
    responses: OnboardingResponses,
): Promise<void> =>
    sdkRequest(getOnboardingResponsesUrl(organizationId), {
        method: 'POST',
        body: JSON.stringify(responses),
    });
